import { render } from "./appIntegrated.vue?vue&type=template&id=4d6c732f"
import script from "./appIntegrated.vue?vue&type=script&lang=js"
export * from "./appIntegrated.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"cartridges/app_project_travels/cartridge/client/default/js/plp_lp/appIntegrated.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d6c732f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d6c732f', __exports__)) {
    api.reload('4d6c732f', __exports__)
  }
  
  module.hot.accept("./appIntegrated.vue?vue&type=template&id=4d6c732f", () => {
    api.rerender('4d6c732f', render)
  })

}


export default __exports__